import makeStyles from '@material-ui/core/styles/makeStyles';

export default makeStyles(theme => ({
  filter: {
    minHeight: 420,
    maxheight: 455,
    width: 500,
    overflowY: 'visible !important',
  },
  dilalogContent: {
    overflowY: 'visible !important',
  },
  chip: {
    backgroundColor: theme.palette.background.primary.light,
    color: theme.palette.primary.main,
  },
  siteChip: {
    backgroundColor: theme.palette.warning.main,
  },
  deviceChip: {
    backgroundColor: 'rgb(0, 160, 255)',
  },
  nicknameChip: {
    backgroundColor: 'rgb(119, 205, 45)',
  },
}));
